import { createGlobalStyle } from "styled-components";
import { getFontFamily } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// importing Brandon fonts
import {
  BrandonBlack,
  BrandonBold,
  BrandonLight,
  BrandonMedium,
  BrandonRegular,
  BrandonThin,
  BrandonBlackItalic,
  BrandonBoldItalic,
  BrandonLightItalic,
  BrandonMediumItalic,
  BrandonRegularItalic,
  BrandonThinItalic,
} from "@racepointenergy/gatsby-theme-sitespark/src/fonts/brandon";
import {
  MillerDisplayRoman,
  MillerRegular,
} from "@racepointenergy/gatsby-theme-sitespark/src/fonts/miller";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'brandon-black';
    src: url('${BrandonBlack}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-bold';
    src: url('${BrandonBold}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-light';
    src: url('${BrandonLight}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-medium';
    src: url('${BrandonMedium}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-regular';
    src: url('${BrandonRegular}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-thin';
    src: url('${BrandonThin}') format('otf');
  }

  @font-face {
    font-family: 'brandon-black-italic';
    src: url('${BrandonBlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-bold-italic';
    src: url('${BrandonBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-light-italic';
    src: url('${BrandonLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-medium-italic';
    src: url('${BrandonMediumItalic}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-regular-italic';
    src: url('${BrandonRegularItalic}') format('opentype');
  }

  @font-face {
    font-family: 'brandon-thin-italic';
    src: url('${BrandonThinItalic}') format('opentype');
  }

  @font-face {
    font-family: 'miller';
    src: url('${MillerRegular}') format('opentype');
  }

  @font-face {
    font-family: 'miller-display-roman';
    src: url('${MillerDisplayRoman}') format('opentype');
  }

  html,
  body {
    ${getFontFamily("regular")({ theme: { fontFamily: "brandon" } })}
    font-size: 16px;
  }

  .gatsby-image-wrapper {
    display: contents;
  }

  
`;

export default GlobalStyles;
